import styled from 'styled-components';
import PropTypes from 'prop-types';

const Table = styled.table`
    border-collapse: collapse;
    border-spacing: 0;
    font-size: 12px;
`;
const TableHeader = styled.thead``;
const HeaderRow = styled.tr`
    height: 40px;

    @media print {
        border-top: 2px solid #333;
        border-bottom: 2px solid #333;
    }
`;
const HeaderCell = styled.th.attrs((props) =>
    props.$width ? { style: { width: props.$width } } : {}
)`
    background: #666;
    color: #fff;
    border-bottom: 4px solid #fff;
    padding: 3px 16px;
    box-sizing: border-box;

    @media print {
        border-bottom: none;
    }
`;
const TableBody = styled.tbody``;
const Row = styled.tr`
    @media print {
        border-bottom: 1px solid #ccc;
    }
`;

const DividerRow = styled.tr`
    height: 32px;
`;

const Cell = styled.td`
    border-bottom: 4px solid #fff;
    background: #ccc;
    padding: 4px 4px;

    & input {
        border: none;
        display: block;
        /* background: #eee; */
    }

    @media print {
        border-bottom: none;
    }
`;

const IonTable = ({ columns, data, style, className }) => {
    if (!columns || !data) {
        return null;
    }

    return (
        <Table {...{ style, className }}>
            <TableHeader>
                <HeaderRow>
                    {columns.map((col, i) => {
                        let style;
                        if (col.cellStyle) {
                            if (typeof col.cellStyle === 'function') {
                                style = col.cellStyle(null);
                            } else {
                                style = col.cellStyle;
                            }
                        }
                        return (
                            <HeaderCell
                                key={col.id || i}
                                $width={col.width}
                                style={style}
                            >
                                {col.label}
                            </HeaderCell>
                        );
                    })}
                </HeaderRow>
            </TableHeader>
            <TableBody>
                {data.map((rowData, r) => {
                    if (!rowData) {
                        return <DividerRow key={`div-${r}`} />;
                    }
                    return (
                        <Row key={r}>
                            {columns.map((col, c) => {
                                let style;
                                if (col.cellStyle) {
                                    if (typeof col.cellStyle === 'function') {
                                        style = col.cellStyle(rowData, r);
                                    } else {
                                        style = col.cellStyle;
                                    }
                                }
                                return (
                                    <Cell key={`${r}-${c}`} style={style}>
                                        {col.formatter
                                            ? col.formatter(rowData, r, c)
                                            : rowData[c]}
                                    </Cell>
                                );
                            })}
                        </Row>
                    );

                    // if (Array.isArray(rowData)) {}
                })}
            </TableBody>
        </Table>
    );
};

IonTable.propTypes = {
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.node,
            width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            cellStyle: PropTypes.object,
            formatter: PropTypes.func, // (data)row, row, column => node
        })
    ),
    data: PropTypes.arrayOf(PropTypes.any), // the rows
};

export default IonTable;
